<template>
  <div>
    <div id="selectedPackage" v-if="active_page>=2 && active_page!=8"><!-- selected-package -->
      <div class="selected-package" id="selected-package">
        <div class="container">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-5  package">
                <div class="row">
                  <h3 class="text text-nowrap">{{$t('analysis_order.selected_package_label')}}:</h3>
                  <h3 class="text-color">{{selected_package[localize('name')]}}</h3>
                </div>
              </div>
              <div class="col-lg-5  package">
                <div class="row">
                  <h3 class="text">{{$t('analysis_order.price')}}:</h3>
                  <h3 class="text-color text-nowrap">{{priceTotal}} zł</h3>
                </div>
              </div>
              <div class="col-lg-2  text-right">
                <div><a href="#" class="btn btn-darker" @click="changePackage">{{$t('analysis_order.change_package_button_label')}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <breadcrumb :active_page="active_page"></breadcrumb>

    <!-- order-package -->
    <section class="order-package" id="packageGroup" v-if="isPageActive(1)">
      <div class="container">
        <div class="col-12 head">
          <h2 class="title">{{$t('analysis_order.header')}}</h2>
          <p class="text">{{$t('analysis_order.text1')}}</p>
        </div>
        <div class="package-items">
          <div class="row">
            <div class="col-lg-3 col-md-6 container">
              <div class="package-item basic">
                <div class="row head">
                  <div class="col-6 type">{{analysis_packages[0][localize('name')]}}</div>
                  <div class="col-3">{{analysis_packages[0].price | currency}}</div>
                  <div class="col-2 currency">PLN</div>
                </div>
                <p class="card-text">{{$t('analysis_order.text2')}}</p>
                <ul class="list-group ">
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('analysis_order.text2_p1')}}</p>
                  </li>
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('analysis_order.text2_p2')}}</p>
                  </li>
                </ul>
                <div class="row d-flex justify-content-center">
                  <button type="button" class="btn btn-dark basic" data-toggle="collapse" data-target="#readMoreBasic"
                          aria-expanded="false" aria-controls="readMore">{{$t('analysis_order.more_info_button_label')}}
                  </button>
                  <button type="button" class="btn btn-main" @click="selectPackage(analysis_packages[0])">
                    {{$t('analysis_order.select_package_button_label')}}
                  </button>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 container">
              <div class="package-item advanced">
                <div class="row head">
                  <div class="col-6 type">{{analysis_packages[1][localize('name')]}}</div>
                  <div class="col-3">{{analysis_packages[1].price | currency}}</div>
                  <div class="col-2 currency">PLN</div>
                </div>
                <p class="card-text">{{$t('analysis_order.text3')}}</p>
                <ul class="list-group ">
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('analysis_order.text3_p1')}}</p>
                  </li>
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('analysis_order.text3_p2')}}</p>
                  </li>
                </ul>
                <div class="row d-flex justify-content-center">
                  <button type="button" class="btn btn-dark advanced" data-toggle="collapse"
                          data-target="#readMoreAdvanced" aria-expanded="false" aria-controls="readMore">
                    {{$t('analysis_order.more_info_button_label')}}
                  </button>
                  <button type="button" class="btn btn-main" @click="selectPackage(analysis_packages[1])">
                    {{$t('analysis_order.select_package_button_label')}}
                  </button>
                </div>
              </div>
            </div>


            <div class="col-lg-3 col-md-6 container">
              <div class="package-item premium">
                <div class="row head">
                  <div class="col-6 type">{{analysis_packages[2][localize('name')]}}</div>
                  <div class="col-3">{{analysis_packages[2].price | currency}}</div>
                  <div class="col-2 currency">PLN</div>
                </div>
                <p class="card-text">{{$t('analysis_order.text4')}}</p>
                <ul class="list-group ">
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('analysis_order.text4_p1')}}</p>
                  </li>
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('analysis_order.text4_p2')}}</p>
                  </li>
                </ul>
                <div class="row d-flex justify-content-center">
                  <button type="button" class="btn btn-dark premium" data-toggle="collapse"
                          data-target="#readMorePremium" aria-expanded="false" aria-controls="readMore">
                    {{$t('analysis_order.more_info_button_label')}}
                  </button>
                  <button type="button" class="btn btn-main" @click="selectPackage(analysis_packages[2])">
                    {{$t('analysis_order.select_package_button_label')}}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 container">
              <div class="package-item premium-plus">
                <div class="row head">
                  <div class="col-6 type">{{analysis_packages[3][localize('name')]}}</div>
                  <div class="col-3">{{analysis_packages[3].price | currency}}</div>
                  <div class="col-2 currency">PLN</div>
                </div>
                <p class="card-text">{{$t('analysis_order.text5')}}</p>
                <ul class="list-group ">
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('analysis_order.text5_p1')}}</p>
                  </li>
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('analysis_order.text5_p2')}}</p>
                  </li>
                </ul>
                <div class="row d-flex justify-content-center">
                  <button type="button" class="btn btn-dark premium-plus" data-toggle="collapse"
                          data-target="#readMorePremiumPlus" aria-expanded="false" aria-controls="readMore">
                    {{$t('analysis_order.more_info_button_label')}}
                  </button>
                  <button type="button" class="btn btn-main" @click="selectPackage(analysis_packages[3])">
                    {{$t('analysis_order.select_package_button_label')}}
                  </button>
                </div>
              </div>
            </div>

          </div>

        </div>

        <div class="collapse" id="readMorePremiumPlus" data-parent="#packageGroup">
          <div class="card card-body">
            <div class="col-12 head">
              <h2 class="title">{{analysis_packages[3][localize('name')]}}</h2>
              <p class="text">{{analysis_packages[3][localize('description')]}}</p>
            </div>
          </div>
        </div>

        <div class="collapse" id="readMorePremium" data-parent="#packageGroup">
          <div class="card card-body">
            <div class="col-12 head">
              <h2 class="title">{{analysis_packages[2][localize('name')]}}</h2>
              <p class="text">{{analysis_packages[2][localize('description')]}}</p>
            </div>
          </div>
        </div>

        <div class="collapse" id="readMoreAdvanced" data-parent="#packageGroup">
          <div class="card card-body">
            <div class="col-12 head">
              <h2 class="title">{{analysis_packages[1][localize('name')]}}</h2>
              <p class="text">{{analysis_packages[1][localize('description')]}}</p>
            </div>
          </div>
        </div>

        <div class="collapse" id="readMoreBasic" data-parent="#packageGroup">
          <div class="card card-body">
            <div class="col-12 head">
              <h2 class="title">{{analysis_packages[0][localize('name')]}}</h2>
              <p class="text">{{analysis_packages[0][localize('description')]}}</p>
            </div>
          </div>
        </div>

      </div>
    </section>

    <!--package-set -->
    <section class="package-set" v-if="isPageActive(2)">
      <div class="container">
        <div class="col-12">
          <h2 class="title">{{$t('collection_set')}}</h2>
          <p class="text">{{$t('analysis_order.text6')}} </p>
        </div>

        <div class="col-lg-6 col-md-12">
          <div class="row text-center row-buttons">
            <div class="col">
              <a href="#" :class="[picked_collection_set_option == 'order'?'btn-main':'btn-white','btn']">
                {{$t('collection_set_order.order_new_set')}}</a>
              <a href="#" :class="[picked_collection_set_option == 'have'?'btn-main':'btn-white','btn']">
                {{$t('collection_set_order.set_is_registered')}}</a>
              <a v-if="isLoggedIn && user.state == 3" href="#" :class="[picked_collection_set_option == 'have-logged-in'?'btn-main':'btn-white','btn']">
                {{$t('collection_set_order.use_set_nr')}} {{user.registration_code}}</a>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="row">
            <div class="col-lg-3 col-md-12">
              <h4 class="items">Choose method:</h4>
              <div class="form-check">
                <input class="form-check-input  css-checkbox" type="radio" name="paymentMethod" id="paymentMethod1"
                       value="paymentMethod1" checked="checked">
                <label class="form-check-label  css-label text" for="paymentMethod1">
                  Courier service
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input  css-checkbox" type="radio" name="paymentMethod" id="paymentMethod2"
                       value="paymentMethod2">
                <label class="form-check-label  css-label text" for="paymentMethod2">
                  Personal pickup
                </label>
              </div>
            </div>

            <div class="col-lg-7 col-md-12 offset-1">
              <h4 class="items">{{$t('collection_set_order.payment_details')}}</h4>

              <form action="reg-3" class="main-form needs-validation-delivery" novalidate="">
                <div class="col">
                  <div class="form-group row">
                    <label for="inputName" class="col-sm-4 col-form-label">{{$t('collection_set_order.name')}}</label>
                    <div class="col-sm-8">
                      <input type="text" name="inputName" id="inputName" class="form-control" required="">
                      <div class="invalid-feedback">{{$t('required')}}</div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="inputSurname" class="col-sm-4 col-form-label">{{$t('collection_set_order.surname')}}</label>
                    <div class="col-sm-8">
                      <input type="text" name="inputSurname" id="inputSurname" class="form-control" required="">
                      <div class="invalid-feedback">{{$t('required')}}</div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="inputStreet" class="col-sm-4 col-form-label">{{$t('collection_set_order.street_and_local_no')}}</label>
                    <div class="col-sm-8">
                      <input type="text" name="inputStreet" id="inputStreet" class="form-control" required="">
                      <div class="invalid-feedback">{{$t('required')}}</div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="inputZipcode" class="col-sm-4 col-form-label">{{$t('collection_set_order.postal_code')}}</label>
                    <div class="col-sm-8">
                      <input type="text" name="inputZipcode" id="inputZipcode" class="form-control" required="">
                      <div class="invalid-feedback">{{$t('required')}}</div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="inputTown" class="col-sm-4 col-form-label">{{$t('collection_set_order.city')}}</label>
                    <div class="col-sm-8">
                      <input type="text" name="inputTown" id="inputTown" class="form-control" required="">
                      <div class="invalid-feedback">{{$t('required')}}</div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="inputPhone" class="col-sm-4 col-form-label">{{$t('collection_set_order.phone')}}</label>
                    <div class="col-sm-8">
                      <input type="text" name="inputPhone" id="inputPhone" class="form-control" required="">
                      <div class="invalid-feedback">{{$t('required')}}</div>
                    </div>
                  </div>

                </div>
              </form>


            </div>
          </div>
        </div>

        <div class="row text-center buttons">
          <div class="col">
            <a href="/#/todo" class="btn btn-main">
              {{$t('collection_set_order.continue_button_label')}}</a>
          </div>
        </div>
      </div>
    </section>


    <div v-if="isPageActive(2)">
      <form class="p-5">
        <h4>{{$t('collection_set_order.select_collection_set')}}</h4>
        <div class="custom-control custom-radio mb-4">
          <input class="custom-control-input" type="radio" name="collection_set_option"
                 id="collection_set_option_order"
                 value="order" v-model="picked_collection_set_option" checked>
          <label class="custom-control-label" for="collection_set_option_order">
            {{$t('collection_set_order.order_new_set')}}
          </label>
        </div>

        <div class="custom-control custom-radio mb-4" v-if="!isLoggedIn">
          <input class="custom-control-input" type="radio" name="collection_set_option"
                 id="collection_set_option_have"
                 value="have" v-model="picked_collection_set_option">
          <label class="custom-control-label" for="collection_set_option_have">
            {{$t('collection_set_order.set_is_registered')}}
          </label>
        </div>

        <div class="custom-control custom-radio mb-4" v-if="isLoggedIn && user.state == 3">
          <input class="custom-control-input" type="radio" name="collection_set_option"
                 id="collection_set_option_have_logged_in"
                 value="have_logged_in" v-model="picked_collection_set_option">
          <label class="custom-control-label" for="collection_set_option_have_logged_in">
            {{$t('collection_set_order.use_set_nr')}} {{user.registration_code}}
          </label>
        </div>

        <div v-if="render_delivery_address_form">
          <form class="border border-light p-5">

            <p class="h4 mb-4 text-center">{{$t('collection_set_order.select_delivery_method')}}:</p>

            <div class="custom-control custom-radio mb-4">
              <input type="radio" class="custom-control-input" id="delivery_type_personal"
                     name="collection_set_delivery_type" v-model="picked_collection_set_delivery_type"
                     :value="delivery_types.personal">
              <label class="custom-control-label" for="delivery_type_personal">
                {{delivery_types.personal[localize('name')]}}</label>
            </div>

            <div class="custom-control custom-radio mb-4">
              <input type="radio" class="custom-control-input" id="delivery_type_courier"
                     name="collection_set_delivery_type" v-model="picked_collection_set_delivery_type"
                     :value="delivery_types.courier">
              <label class="custom-control-label" for="delivery_type_courier">
                {{delivery_types.courier[localize('name')]}}</label>
            </div>

            <div class="custom-control custom-radio mb-4">
              <input type="radio" class="custom-control-input" id="delivery_type_post"
                     name="collection_set_delivery_type" v-model="picked_collection_set_delivery_type"
                     :value="delivery_types.post">
              <label class="custom-control-label"
                     for="delivery_type_post">{{delivery_types.post[localize('name')]}}</label>
            </div>
            <div v-if="render_delivery_address_fields">
              <label for="delivery_name">{{$t('collection_set_order.name')}}</label>
              <input type="text" id="delivery_name" class="form-control"
                     placeholder="Imię" v-model="delivery_data.name">

              <label for="delivery_surname">{{$t('collection_set_order.surname')}}</label>
              <input type="text" id="delivery_surname" class="form-control"
                     placeholder="Nazwisko" v-model="delivery_data.surname">

              <label for="delivery_address">{{$t('collection_set_order.adress')}}</label>
              <textarea id="delivery_address" class="form-control mb-4" placeholder="Textarea"
                        v-model="delivery_data.address"></textarea>

              <label for="delivery_email">{{$t('register.email')}}</label>
              <input type="email" id="delivery_email" class="form-control mb-4"
                     placeholder="E-mail" v-model="delivery_data.email">

              <label for="delivery_phone">{{$t('register.phone_no')}}</label>
              <input type="text" id="delivery_phone" class="form-control"
                     placeholder="Phone number" v-model="delivery_data.phone">
            </div>

          </form>
        </div>

        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog"
             aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{$t('register.login_using_code')}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <label for="code">{{$t('register.code')}}:</label>
                    <input type="text" class="form-control"
                           v-bind:class="{'is-invalid':login_error}" id="code"
                           aria-describedby="codeHelp"
                           placeholder="Podaj kod z zestawu" v-model="code">
                    <div class="invalid-feedback">
                      {{login_error}}
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="password">{{$t('register.password')}}</label>
                    <input type="password" class="form-control" id="password" placeholder="Hasło"
                           v-model="password">
                  </div>

                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">{{$t('close')}}</button>
                <button type="button" @click="login()" class="btn btn-primary">{{$t('submit')}}</button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <button type="button" class="btn btn-success" @click="confirmCollectionSet">
        {{$t('analysis_order.continue_button_label')}}
      </button>
    </div>

    <div div v-if="isPageActive(3)">
      <form>
        <h2>{{$t('analysis_order.choose_medium')}}:</h2>
        <div class="form-check">
          <input class="form-check-input" type="radio" :value="data_carriers.cloud" id="cloud_check"
                 v-model="package_settings.data_carrier" name="data_carrier_type">
          <label class="form-check-label" for="cloud_check">
            {{data_carriers.cloud[localize('name')]}}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" :value="data_carriers.pendrive" id="pendrive_check"
                 v-model="package_settings.data_carrier" name="data_carrier_type">
          <label class="form-check-label" for="pendrive_check">
            {{data_carriers.pendrive[localize('name')]}}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" :value="data_carriers.egg_basic" id="egg_basic_check"
                 v-model="package_settings.data_carrier" name="data_carrier_type">
          <label class="form-check-label" for="egg_basic_check">
            {{data_carriers.egg_basic[localize('name')]}}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" :value="data_carriers.egg_brown" id="egg_brown_check"
                 v-model="package_settings.data_carrier" name="data_carrier_type">
          <label class="form-check-label" for="egg_brown_check">
            {{data_carriers.egg_brown[localize('name')]}}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" :value="data_carriers.egg_flying" id="egg_flying_check"
                 v-model="package_settings.data_carrier" name="data_carrier_type">
          <label class="form-check-label" for="egg_flying_check">
            {{data_carriers.egg_flying[localize('name')]}}
          </label>
        </div>
        <p>* potrzebna jest jakaś graficzna forma prezentacji nośników</p>
      </form>

      <div v-if="package_settings.data_carrier != data_carriers.cloud">
        <form class="border border-light p-5">

          <p class="h4 mb-4 text-center">{{$t('analysis_order.choose_medium_delivery_method')}}:</p>

          <div class="custom-control custom-radio mb-4" v-if="picked_collection_set_option == 'order'">
            <input type="radio" class="custom-control-input" id="data_carrier_delivery_type_same"
                   name="data_carrier_delivery_type" v-model="picked_data_carrier_delivery_type"
                   :value="delivery_types.same">
            <label class="custom-control-label" for="data_carrier_delivery_type_same">{{delivery_types.same[localize('name')]}}</label>
          </div>

          <div class="custom-control custom-radio mb-4">
            <input type="radio" class="custom-control-input" id="data_carrier_delivery_type_personal"
                   name="data_carrier_delivery_type" v-model="picked_data_carrier_delivery_type"
                   :value="delivery_types.personal">
            <label class="custom-control-label" for="data_carrier_delivery_type_personal">{{delivery_types.personal[localize('name')]}}</label>
          </div>

          <div class="custom-control custom-radio mb-4">
            <input type="radio" class="custom-control-input" id="data_carrier_delivery_type_courier"
                   name="data_carrier_delivery_type" v-model="picked_data_carrier_delivery_type"
                   :value="delivery_types.courier">
            <label class="custom-control-label" for="data_carrier_delivery_type_courier">
              {{delivery_types.courier[localize('name')]}}</label>
          </div>

          <div class="custom-control custom-radio mb-4">
            <input type="radio" class="custom-control-input" id="data_carrier_delivery_type_post"
                   name="data_carrier_delivery_type" v-model="picked_data_carrier_delivery_type"
                   :value="delivery_types.post">
            <label class="custom-control-label" for="data_carrier_delivery_type_post">
              {{delivery_types.post[localize('name')]}}</label>
          </div>
          <div v-if="render_data_carrier_delivery_address_fields">
            <label for="data_carrier_delivery_name">{{$t('register.name')}}</label>
            <input type="text" id="data_carrier_delivery_name" class="form-control"
                   placeholder="Imię" v-model="data_carrier_delivery_data.name">

            <label for="data_carrier_delivery_surname">{{$t('register.surname')}}</label>
            <input type="text" id="data_carrier_delivery_surname" class="form-control"
                   placeholder="Nazwisko" v-model="data_carrier_delivery_data.surname">

            <label for="data_carrier_delivery_address">{{$t('register.adress')}}</label>
            <textarea id="data_carrier_delivery_address" class="form-control mb-4" placeholder="Textarea"
                      v-model="data_carrier_delivery_data.address"></textarea>

            <label for="data_carrier_delivery_email">{{$t('register.email')}}</label>
            <input type="email" id="data_carrier_delivery_email" class="form-control mb-4"
                   placeholder="E-mail" v-model="data_carrier_delivery_data.email">

            <label for="data_carrier_delivery_phone">{{$t('register.phone_no')}}</label>
            <input type="text" id="data_carrier_delivery_phone" class="form-control"
                   placeholder="Phone number" v-model="data_carrier_delivery_data.phone">
          </div>

        </form>
      </div>
      <button type="button" class="btn btn-success" @click="confirmDataCarrier">
        {{$t('analysis_order.continue_button_label')}}
      </button>
    </div>
    <div div v-if="isPageActive(4)">
      <div class="row">
        {{$t('consultation.date_from')}}:
        <datepicker placeholder="RRRR-MM-DD" format="yyyy-MM-dd"
                    v-model="consultations_filter_date_from"></datepicker>
        {{$t('consultation.date_to')}}:
        <datepicker placeholder="RRRR-MM-DD" format="yyyy-MM-dd"
                    v-model="consultations_filter_date_to"></datepicker>
        <button class="btn btn-success">{{$t('consultation.search')}}</button>
      </div>
      <ul class="list-group" v-if="selected_consultation">
        {{$t('consultation.selected_date')}}:
        <li class="list-group-item d-flex justify-content-between align-items-center">
          {{selected_consultation.date}} {{selected_consultation.time}} {{selected_consultation.doctor.name}}
          <button class="btn btn-sm btn-dark" @click="cancelConsultation(selected_consultation)">
            {{$t('cancel')}}
          </button>
        </li>
      </ul>
      {{$t('consultation.info1')}}:
      <ul class="list-group" v-for="cl in consultations_list">
        <li class="list-group-item d-flex justify-content-between align-items-center">
          {{cl.date}} {{cl.time}} {{cl.doctor.name}}
          <button class="btn btn-sm btn-success" @click="selectConsultation(cl)"
                  v-if="!selected_consultation">{{$t('select')}}
          </button>
          <button class="btn btn-sm btn-success" @click="changeConsultation(cl)"
                  v-if="selected_consultation">{{$t('change')}}
          </button>
        </li>
      </ul>
      <button type="button" class="btn btn-success" @click="gotoPage(6)">
        {{$t('Back')}}
      </button>
      <button type="button" class="btn btn-success" @click="confirmConsultation()">
        {{$t('consultation.accept_go_to_summary')}}
      </button>
    </div>
    <div div v-if="isPageActive(5)">
      <h2>{{$t('summary')}}</h2>
      <div class="row">
        <div>
                    <span>{{$t('analysis_order.selected_package_label')}}: {{selected_package[localize('name')]}}
                        <button class="btn btn-sm btn-dark" @click="changePackage">{{$t('analysis_order.change_package_button_label')}}</button>
                    </span>

        </div>
      </div>
      <div class="row">
        <div v-if="picked_collection_set_option == 'order'">
          <div>{{$t('collection_set_order.order_set_confirm')}}</div>
          <div>{{$t('collection_set_order.delivery_method')}}: {{picked_collection_set_delivery_type[localize('name')]}}
            <button class="btn btn-sm btn-dark" @click="gotoPage(2)">
              {{$t('analysis_order.change_package_button_label')}}
            </button>
          </div>
          <div
            v-if="(picked_collection_set_delivery_type == delivery_types.post) || (picked_collection_set_delivery_type == delivery_types.courier)">
            {{$t('collection_set_order.delivery_adress')}}: {{delivery_data.name}} {{delivery_data.surname}}, {{delivery_data.address}}, 
            {{$t('collection_set_order.phone')}} {{delivery_data.phone}}, 
            {{$t('register.email')}} {{delivery_data.email}}
          </div>
        </div>
        <div v-if="picked_collection_set_option != 'order'">Wykorzystam mój zarejestrowany zestaw nr
          {{user.registration_code}}
        </div>
      </div>
      <div class="row">
        <div>{{$t('analysis_order.data_storage_medium')}}: {{package_settings.data_carrier[localize('name')]}}
          <button class="btn btn-sm btn-dark" @click="gotoPage(5)">
            {{$t('analysis_order.change_package_button_label')}}
          </button>
          <div
            v-if="(picked_data_carrier_delivery_type == delivery_types.post) || (picked_data_carrier_delivery_type == delivery_types.courier)">
            {{$t('collection_set_order.delivery_adress')}}: {{data_carrier_delivery_data.name}} {{data_carrier_delivery_data.surname}},
            {{data_carrier_delivery_data.address}}, 
            {{$t('collection_set_order.phone')}} {{data_carrier_delivery_data.phone}}, 
            {{$t('register.email')}} {{data_carrier_delivery_data.email}}
          </div>
        </div>
      </div>
      <div class="row">
        <div>{{$t('consultation.consultation')}}: {{selected_consultation.date}} {{selected_consultation.time}}
          {{selected_consultation.doctor.name}}
          <button class="btn btn-sm btn-dark" @click="gotoPage(7)">
            {{$t('analysis_order.change_package_button_label')}}
          </button>
        </div>
      </div>
      <div class="row">
        <h3>{{$t('analysis_order.price')}}:{{priceTotal}} zł</h3>
      </div>

      <button id="confirm_order_button" type="button" class="btn btn-success" @click="confirmAndPay">
        {{$t('collection_set_order.order_button_label')}}
      </button>


    </div>
    <div div v-if="isPageActive(6)">
      {{$t('breadcrumb_collection_set.payment')}}
      <h2 id="payment_header">{{$t('collection_set_order.order_placed_header')}}</h2>
      <h3>{{$t('collection_set_order.your_order_number')}} <span id="order_number">{{survey_hash}}</span></h3>
      <form action="https://ssl.dotpay.pl/test_payment/" method="POST">
        <input type="hidden" name='id' id="id" :value="shop_id"/>
        <input type="hidden" name='amount' id="amount" :value="priceTotal"/>
        <input type="hidden" name="currency" id="currency" value="PLN"/>
        <input type="hidden" name="chk" id="chk" :value="payment_checksum"/>
        <input type="hidden" name="description" id="description" :value="survey_hash"/>
        <input type="hidden" name="url" id="url" value="http://localhost:8000/#/payment/success"/>
        <input type="hidden" name="type" id="type" value="0"/>
        <button id="pay_button" type="submit" class="btn btn-success">
          {{$t('collection_set_order.pay_button_label')}}
        </button>
      </form>
    </div>
  </div>

</template>

<script>
  import Breadcrumb from "../components/Breadcrumb";
  import {
    FETCH_ANALYSIS_PACKAGES,
    HANDLE_LOGIN,
    FETCH_USER,
    FETCH_COUNTRIES,
    FETCH_CONSULTATION_LIST, BOOK_CONSULTATION, CANCEL_CONSULTATION, ORDER_ANALYSIS
  } from '../store/actions';
  import {mapGetters} from 'vuex';
  import translatorMixin from '../mixins/translatorMixin';
  import Datepicker from 'vuejs-datepicker';
  import JQuery from 'jquery'

  let $ = JQuery

  export default {
    name: "AnalysisOrder",
    components: {Breadcrumb, Datepicker},
    mixins: [translatorMixin],
    data: function () {
      return {
        active_page: 1,
        selected_package: '',
        RADIO_ONE: 1,
        CHECKBOX_MANY: 2,
        INPUT_INTEGER: 3,
        FREE_TEXT: 4,
        picked_collection_set_option: 'order',
        is_login_dialog_visible: false,
        selected_more_info_package: 0,
        code: '',
        password: '',
        errors: {},
        login_error: '',
        package_settings: {
          analysis_range: {
            brovar_400_genes: false,
            brovar_hgmd: false,
            unverified_regions_ngs: false
          },
          additional_tests: {
            farmakogenomics: false,
            nutrigenomics: false,
            mitochondrium: false,
            kariotype: false
          },
          data_carrier: ''
        },
        show_more_info_range: '',
        delivery_types: {
          personal: {
            id: 1,
            name_pl: 'Odbiór osobisty',
            name_en: 'Collection in person'
          },
          courier: {
            id: 2,
            name_pl: 'Kurier',
            name_en: 'Courier'
          },
          post: {
            id: 3,
            name_pl: 'Poczta Polska',
            name_en: 'Postal service'
          },
          same: {
            id: 4,
            name_pl: 'Taki sam jak przy zamówieniu zestawu pobraniowego',
            name_en: 'Same as collection set delivery address'
          },
        },
        data_carriers: {
          cloud: {
            id: 1,
            name_pl: 'dane do pobrania z chmury',
            name_en: 'download data from cloud',
            price: 0
          },
          pendrive: {
            id: 2,
            name_pl: 'nośnik podstawowy',
            name_en: 'pendrive',
            price: 300
          },
          egg_basic: {
            id: 3,
            name_pl: 'jajo podstawowe',
            name_en: 'egg basic',
            price: 1000
          },
          egg_brown: {
            id: 4,
            name_pl: 'jajo brązowe',
            name_en: 'egg brown',
            price: 2500
          },
          egg_flying: {
            id: 5,
            name_pl: 'jajo latające',
            name_en: 'egg flying',
            price: 500
          }
        },
        picked_collection_set_delivery_type: '',
        picked_data_carrier_delivery_type: '',
        delivery_data: {
          name: '',
          surname: '',
          address: '',
          email: '',
          phone: ''
        },
        data_carrier_delivery_data: {
          name: '',
          surname: '',
          address: '',
          email: '',
          phone: ''
        },
        survey_hash: '',
        consultations_list: [],
        selected_consultation: '',
        consultations_filter_date_from: '',
        consultations_filter_date_to: '',
        payment_checksum: ''
      }
    },
    computed: {
      ...mapGetters(['analysis_packages', 'survey', 'isLoggedIn', 'user', 'countries', 'shop_id']),
      priceTotal: function () {
        return parseInt(this.selected_package.price) + this.package_settings.data_carrier.price;
      },
      render_delivery_address_form: function () {
        if (this.picked_collection_set_option == 'order') {
          return true;
        } else {
          return false;
        }
      },
      render_delivery_address_fields: function () {
        if ((this.picked_collection_set_delivery_type == this.delivery_types.courier) || (this.picked_collection_set_delivery_type == this.delivery_types.post)) {
          return true;
        } else {
          return false;
        }
      },
      render_data_carrier_delivery_address_fields: function () {
        if ((this.picked_data_carrier_delivery_type == this.delivery_types.courier) || (this.picked_data_carrier_delivery_type == this.delivery_types.post)) {
          return true;
        } else {
          return false;
        }
      }
    },
    mounted: function () {
      this.$store.dispatch(FETCH_ANALYSIS_PACKAGES);
      this.$store.dispatch(FETCH_COUNTRIES);
      this.picked_collection_set_delivery_type = this.delivery_types.personal;
      this.picked_data_carrier_delivery_type = this.delivery_types.personal;
      this.package_settings.data_carrier = this.data_carriers.cloud;
    },
    methods: {
      isPageActive: function (page) {
        return this.active_page == page;
      },
      gotoPage: function (page) {
        this.active_page = page;
      },
      selectPackage: function (analysis_package) {
        this.selected_package = analysis_package;

        this.gotoPage(2);
      },
      confirmCollectionSet: function () {
        if (this.picked_collection_set_option == 'have') {
          this.is_login_dialog_visible = true;
          $('#exampleModal').modal('show');
        } else {
          this.gotoPage(3);
        }
      },
      confirmDataCarrier: function () {
        this.loadConsultationList();
        this.gotoPage(4);
      },
      showMoreInfoView: function (analysis_package_id) {
        this.selected_more_info_package = analysis_package_id;
        document.getElementById('more_info_box').scrollIntoView({
          behavior: 'smooth'
        });
      },
      getInputId(question_id) {
        return 'question_id_' + question_id;
      },
      login() {
        this.$store.dispatch(HANDLE_LOGIN,
          {
            registration_code: this.code,
            password: this.password
          }).then(result => {
          this.$store.dispatch(FETCH_USER);
          $('#exampleModal').modal('hide');
          this.picked_collection_set_option = 'have_logged_in';
        }).catch(error => {
          this.code = '';
          this.password = '';
          this.login_error = 'Nieprawidłowy login lub hasło';
        });
      },
      changePackage: function () {
        this.active_page = 1;
      },
      showMoreInfoRange: function (name) {
        this.show_more_info_range = name;
      },
      selectConsultation: function (consultation) {
        this.$store.dispatch(BOOK_CONSULTATION, {id: consultation.id, survey_hash: this.survey_hash}).then(
          response => {
            this.selected_consultation = consultation;
          }
        ).catch(error => {
          alert(error)
        });
        this.loadConsultationList();
      },
      cancelConsultation: function (consultation) {
        this.$store.dispatch(CANCEL_CONSULTATION, {id: consultation.id, survey_hash: this.survey_hash}).then(
          response => {
            this.selected_consultation = '';
            this.loadConsultationList();
          }
        ).catch(error => {
          alert(error)
        });

      },
      changeConsultation: function (consultation) {
        this.$store.dispatch(CANCEL_CONSULTATION, {
          id: this.selected_consultation.id,
          survey_hash: this.survey_hash
        }).then(
          response => {
            this.selectConsultation(consultation);
          }
        ).catch(error => {
          alert(error)
        });
      },
      confirmConsultation: function () {
        if (!this.selected_consultation) {
          alert("Proszę wybrać termin konsultacji!");
        } else {
          this.gotoPage(5);
        }
      },
      loadConsultationList() {
        this.$store.dispatch(FETCH_CONSULTATION_LIST).then(
          response => {
            this.consultations_list = response.data;
          }
        ).catch(error => {
          console.log(error);
        });
      },
      confirmAndPay: function () {
        this.$store.dispatch(ORDER_ANALYSIS, {
          survey_hash: this.survey_hash,
          selected_package: this.selected_package,
          picked_collection_set_option: this.picked_collection_set_option,
          package_settings: this.package_settings,
          picked_collection_set_delivery_type: this.picked_collection_set_delivery_type,
          picked_data_carrier_delivery_type: this.picked_data_carrier_delivery_type,
          delivery_data: this.delivery_data,
          data_carrier_delivery_data: this.data_carrier_delivery_data,
          selected_consultation: this.selected_consultation,
          price: this.priceTotal
        }).then(
          response => {
            this.payment_checksum = response.data.payment_checksum
            this.gotoPage(6);
          }
        ).catch(error => {
          console.log(error);
        });
      },
    }
  }


</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/AnalysisOrder.vue